module.exports = __webpack_public_path__ + "static/profil_koncoworoczny_2021_2-84cd5955f903f54a3d9faa59be95b32f.jpg";